module.exports = __webpack_public_path__ + "static/img/ser2.ba08b36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service/ser2.png
// module id = HJ+e
// module chunks = 1